import { create } from 'zustand';
import { getCitiesByState } from '../api/providerApi';

const useCityStore = create((set) => ({
    cities: [],
    loading: false,
    error: null,

    fetchCities: async (stateId) => {
        if (!stateId) {
            set({ cities: [] });
            return;
        }

        set({ loading: true, error: null });

        try {
            const data = await getCitiesByState(stateId);
            set({ cities: data, loading: false });
        } catch (err) {
            set({
                error: err.message || 'Failed to load cities',
                loading: false,
            });
        }
    },

    clearCities: () => set({ cities: [] }),
}));

export default useCityStore;
